/**
 * Strateji sekmesinin üç bölümü.
 *
 * İkisi (`match`, `playbook`) `strategies` tablosunda yaşar ve aynı editörü
 * kullanır — ayrışan tek şey kimin yazabildiği. Üçüncüsü (`points`) ayrı bir
 * sistemdir (`strategic_points`), o yüzden burada yalnızca bir sekme kimliği
 * olarak geçer.
 *
 * Slug'lar **adres dilidir**: bölümler Türkçe adlarıyla linklenir, çünkü URL de
 * arayüzün bir parçası ve panelin dili Türkçe.
 */
export type StrategyKind = 'match' | 'playbook'
export type StrategySection = StrategyKind | 'points'

export const SECTION_SLUG: Record<StrategySection, string> = {
  match: 'mac',
  points: 'noktalar',
  playbook: 'defter',
}

const BY_SLUG: Record<string, StrategySection> = {
  mac: 'match',
  noktalar: 'points',
  defter: 'playbook',
}

/** Tanınmayan slug maç stratejilerine düşer — boş bir bölüm göstermekten iyi. */
export function sectionFromSlug(slug: string | undefined): StrategySection {
  return (slug && BY_SLUG[slug]) || 'match'
}

export const isStrategyKind = (s: StrategySection): s is StrategyKind =>
  s === 'match' || s === 'playbook'

/** Editör adresi: `/strategy/<bölüm>/<harita>?strategy=<id>` */
export function strategyEditorPath(kind: StrategyKind, mapName: string, id?: number): string {
  const base = `/strategy/${SECTION_SLUG[kind]}/${mapName}`
  return id === undefined ? base : `${base}?strategy=${id}`
}

export const sectionPath = (s: StrategySection) => `/strategy/${SECTION_SLUG[s]}`
